import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './AuthLayout.scss'
import { images } from '../../config/images'

class AuthLayout extends Component {
  render() {
    const { showFooter, children } = this.props

    return (
      <div className="AuthLayout__wrapper">
        <div className="AuthLayout__header">
          {showFooter ? (
            <a href="https://yac.com/">
              <img src={images.YAC_logo__black} alt="yac logo" />
            </a>
          ) : (
            <img src={images.YAC_logo__black} alt="yac logo" />
          )}
        </div>
        <div className="AuthLayout__body">{children}</div>
        {showFooter && (
          <>
            <div className="AuthLayout__footer">
              Join 1500+ teams collaborating on Yac
              <div className="AuthLayout__companies-list">
                <img src={images.logo_spotify} alt="spotify" />
                <img src={images.logo_hubspot} alt="hubspot" />
                <img src={images.logo_cbs} alt="cbs" />
                <img src={images.logo_rev} alt="rev.ai" />
                <img src={images.logo_dialpad} alt="dialpad" />
              </div>
            </div>
          </>
        )}
      </div>
    )
  }
}

AuthLayout.propTypes = {
  showFooter: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
}

AuthLayout.defaultProps = {
  showFooter: true,
}

export default AuthLayout
